var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.vcomponent,_vm._b({tag:"component",on:{"submit":function($event){return _vm.$emit('submit', $event)},"input":function($event){return _vm.$emit('input', $event)}}},'component',_vm.opts,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }